import { AlertCircle, Lock, CameraOff } from "lucide-react";
import { Button, Card, CardContent, CardDescription, CardHeader, CardTitle } from "@pushup/ui";

interface CameraErrorProps {
  message: string;
  onRetry?: () => void;
}

export function CameraError({ message, onRetry }: CameraErrorProps) {
  const isSecureContextError = message.includes("secure context");
  const isPermissionError = message.includes("permission");

  return (
    <Card className="mx-auto max-w-lg border-destructive/50 bg-destructive/5">
      <CardHeader>
        <div className="flex items-center gap-3">
          <div className="flex size-10 items-center justify-center rounded-full bg-destructive/10 text-destructive">
            {isSecureContextError ? (
              <Lock className="size-5" />
            ) : isPermissionError ? (
              <CameraOff className="size-5" />
            ) : (
              <AlertCircle className="size-5" />
            )}
          </div>
          <div>
            <CardTitle className="text-lg">Camera Access Issue</CardTitle>
            <CardDescription className="text-xs">
              {isSecureContextError ? "HTTPS / Localhost required" : "Camera unavailable"}
            </CardDescription>
          </div>
        </div>
      </CardHeader>
      <CardContent className="space-y-4">
        <p className="text-sm text-foreground">{message}</p>
        {isSecureContextError && (
          <p className="text-xs text-muted-foreground">
            WebRTC and MediaDevices camera APIs are restricted by browser security policies to
            secure origins (HTTPS or <code>http://localhost</code>).
          </p>
        )}
        {onRetry && (
          <Button variant="outline" size="sm" onClick={onRetry}>
            Try Again
          </Button>
        )}
      </CardContent>
    </Card>
  );
}
